import { CSSProperties, memo } from 'react'
import css from './breadcrumbPaths.module.css'
import cn from '@/utils/cn'
import useBreadcrumbs from './hooks/useBreadcrumbs'

type IProps = {
  paths: string[]
  isToggleButtonVisible?: boolean
  styleMainPath?: CSSProperties
  styleLastPath?: CSSProperties
}

const BreadcrumbPaths = ({ paths, isToggleButtonVisible = false, styleMainPath, styleLastPath }: IProps) => {
  const { containerRef, visiblePaths, showAll, setShowAll, shouldShowToggleButton } = useBreadcrumbs(
    paths,
    isToggleButtonVisible
  )

  const renderPathParts = (items: string[]) =>
    items.map((item, index) => {
      const isLastItem = index === items.length - 1
      return (
        <span
          key={index}
          className={cn({
            [css.lastElement]: isLastItem,
            [css.mainPath]: !isLastItem,
          })}
          style={isLastItem ? styleLastPath : styleMainPath}
        >
          {item}
          {index < items.length - 1 && ' / '}
        </span>
      )
    })

  return (
    <div className={css.container}>
      <div className={css.paths} ref={containerRef} data-open={showAll}>
        {showAll && isToggleButtonVisible ? renderPathParts(paths) : renderPathParts(visiblePaths)}
      </div>
      {shouldShowToggleButton && (
        <div className={css.toggleButton} onClick={() => setShowAll((prev) => !prev)}>
          {showAll ? 'Скрыть' : 'Показать полностью'}
        </div>
      )}
    </div>
  )
}

export default memo(BreadcrumbPaths)
